import React from "react";
import "../Products/Products.css";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
const PASystem = ({ title, imageSrc, description }) => {
  const PASystemDetails = [
    {
      headingname: "Call Station",
      detailsname: "all center is a team of customer service specialists who help field phone calls from customers ......",
      imageSource: process.env.PUBLIC_URL + "assets/images/Products/pa-1.png",
    },
    {
      headingname: "Public Address Speaker",
      detailsname: "A public address system (or PA system) is an electronic system comprising microphones........ ,",
      imageSource: process.env.PUBLIC_URL + "assets/images/Products/pa-2.png",
    },
    {
      headingname: "PA System ",
      detailsname: "A public address system (or PA system) is an electronic system comprising microphones........ ,",
      imageSource: process.env.PUBLIC_URL + "assets/images/Products/pa-3.png",
    },
    {
      headingname: "Amplifiers",
      detailsname: "An electronic amplifier is a device that is used to increase the power, current, or voltage of ..... ",
      imageSource: process.env.PUBLIC_URL + "assets/images/Products/pa-4.png",
    },
    {
      headingname: "PA System",
      detailsname: "A public address system (or PA system) is an electronic system comprising microphones............ ,",
      imageSource: process.env.PUBLIC_URL + "assets/images/Products/pa-5.png",
    },
  ];
  return (
    <>
      <section className="CCTV-System">
        <div className="container">
          <div className="Heading-cctv">
            <div className="heading-about text-center">
              <h4>PA System</h4>
            </div>
            <div className="borders-one d-flex justify-content-center">
              <div className="border-red"></div>
              <div className="border-line "></div>
            </div>
          </div>

          <div className="row justify-content-center">
            {PASystemDetails.map((item, index) => (
              <div key={index} className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-12 mt-4 mt-xl-5 g-5">
                <Card className="IR-Camera mb-3">
                  <Card.Img variant="top" />
                  <div className="Heading-Main">
                    <h1 className="dome-camera">{item.headingname}</h1>
                  </div>

                  <div className="camera-border"></div>
                  <div className="IR-camera-img">
                    <img src={item.imageSource} className="camera-img" />
                  </div>
                  <Card.Body className="IR-Camera-body">
                    <Card.Text>{item.detailsname}</Card.Text>
                    <div className="read-button">
                      <Button variant="read">Read More</Button>
                      <div className="read-border"></div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default PASystem;
